export default __webpack_public_path__ + "images/62_thumbnail.jpg";